import api from './api'; 

const companyService = {
  onboard: async (onboardingData) => {
    try {
      const response = await api.post('/companies/onboard', onboardingData);
      return response.data;
    } catch (error) {
      const payload = error.response?.data || { message: 'Connection to server failed' };
      const err = new Error(payload.message || 'Onboarding failed');
      err.response = error.response;
      throw err;
    }
  }
};

export default companyService;